import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';

/** Marks a row consumed with an NFC card ("Tarjeta Mute"), which is not Mute's revenue. */
export default function MuteCardChip() {
	const { t } = useTranslation();
	return <Chip size="small" color="secondary" variant="outlined" label={t('nfc:muteCard')} sx={{ ml: 1 }} />;
}
